import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AutosaveControlService {
    private dialogStates = new Map<AutosavePage, BehaviorSubject<boolean>>();

    getDialogState(page: AutosavePage) {
        if (!this.dialogStates.has(page)) {
            this.dialogStates.set(page, new BehaviorSubject(false));
        }

        return this.dialogStates.get(page)!.asObservable();
    }

    setDialogOpen(page: AutosavePage, value: boolean) {
        if (!this.dialogStates.has(page)) {
            this.dialogStates.set(page, new BehaviorSubject(false));
        }

        this.dialogStates.get(page)!.next(value);
    }
}

export enum AutosavePage {
    MIMIC = 'mimic',
    CHANNEL = 'channel',
}
